import React from 'react';
import LendoIcon from './LendoIcon';
import './LendoHeader.css';
import LendoMenu from './LendoMenu';

const LendoHeader = () => {
  const trackHeaderNavigation = ({
    trackingId,
    url,
    context,
  }: {
    trackingId: string;
    url: string;
    context?: string;
  }) => {
      window.dataLayer.push({
          event: 'elementInteraction',
          elementInfo: {
              group: 'header',
              id: trackingId,
              url: url,
              context: context,
          },
          eventInfo: {
              interaction: 'click',
          },
      })
  };

  return (
    <header id="header" className="header z-50">
      <div className="header-inner container">
        <div className="header-top-row">
          <div className="logo">
            <a
              href="/"
              title="Lendo"
              onClick={() => trackHeaderNavigation({ trackingId: 'logo', url: '/' })}
            >
              <LendoIcon name="logo" size="30px" />
            </a>
          </div>

          <div className="banner hidden-sm-down">
            <span>
              Ring oss på{' '}
              <a
                className="lendo-click-phone"
                href="tel:22007070"
                onClick={() =>
                  trackHeaderNavigation({
                    url: '/',
                    trackingId: '22 00 70 70',
                    context: 'contact link click',
                  })
                }
              >
                22 00 70 70
              </a>{' '}
              for personlig hjelp til rett lån
            </span>
          </div>

          <div className="desktop-buttons">
            <a
              href="/min-side/logg-inn/"
              className="header-button"
              onClick={(e) => {
                  trackHeaderNavigation({
                      trackingId: 'Lendo SmartØkonomi',
                      url: '/min-side/logg-inn/',
                  })
              }}
            >
              <LendoIcon name="icon/login" size="20px" />
              Lendo SmartØkonomi
            </a>
            <a
              href="/mine-tilbud/"
              className="header-button"
              onClick={(e) => {
                  trackHeaderNavigation({
                      trackingId: 'Mine tilbud',
                      url: '/mine-tilbud/',
                  })
              }}
            >
              Mine tilbud
            </a>
          </div>

          <div className="menu">
            <LendoMenu />
          </div>
        </div>
      </div>
    </header>
  );
};

export default LendoHeader;
